import { render, staticRenderFns } from "./CustomerQuotes.vue?vue&type=template&id=8384196e&scoped=true&"
import script from "./CustomerQuotes.vue?vue&type=script&lang=js&"
export * from "./CustomerQuotes.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuotes.vue?vue&type=style&index=0&id=8384196e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8384196e",
  null
  
)

export default component.exports